/**
 * `/otomatis` — short landing for simple mode (non-tech F0.3). This is the page the
 * PREREQUISITE CHECK block sends people to when they paste an implementation prompt into a
 * chat assistant. Three blocks (describe → Bystep builds → try it on your phone), 5 FAQs, one CTA.
 */
import { createFileRoute } from '@tanstack/react-router'
import { Container, MkFooter, MkLink, MkNav, Overline, SectionHead } from '#/components/landing/mk'
import { m } from '#/paraglide/messages'

export const Route = createFileRoute('/otomatis')({
  head: () => ({
    meta: [
      { title: m.simple_oto_meta_title() },
      { name: 'description', content: m.simple_oto_meta_desc() },
      { property: 'og:title', content: m.simple_oto_meta_title() },
      { property: 'og:description', content: m.simple_oto_meta_desc() },
      { property: 'og:type', content: 'website' },
      { property: 'og:image', content: 'https://bystep.dev/brand/bystep-og.png' },
    ],
  }),
  component: OtomatisPage,
})

function OtomatisPage() {
  const blocks = [
    { t: m.simple_oto_b1_title(), d: m.simple_oto_b1_desc() },
    { t: m.simple_oto_b2_title(), d: m.simple_oto_b2_desc() },
    { t: m.simple_oto_b3_title(), d: m.simple_oto_b3_desc() },
  ]
  const faqs = [
    { q: m.simple_oto_faq_q1(), a: m.simple_oto_faq_a1() },
    { q: m.simple_oto_faq_q2(), a: m.simple_oto_faq_a2() },
    { q: m.simple_oto_faq_q3(), a: m.simple_oto_faq_a3() },
    { q: m.simple_oto_faq_q4(), a: m.simple_oto_faq_a4() },
    { q: m.simple_oto_faq_q5(), a: m.simple_oto_faq_a5() },
  ]
  return (
    <div className="mk h-full overflow-y-auto overflow-x-hidden scroll-smooth">
      <MkNav />
      <main>
        <section className="pt-16 pb-12 lg:pt-24">
          <Container className="flex flex-col items-center gap-6 text-center">
            <Overline>{m.simple_nav_mulai()}</Overline>
            <h1 className="max-w-[18ch]">{m.simple_oto_h1()}</h1>
            <p className="mk-lead max-w-[58ch]">{m.simple_oto_sub()}</p>
            <div className="mt-2 flex flex-wrap justify-center gap-3">
              <MkLink to="/sign-in" search={{ redirect: '/plan?flow=new' }}>
                {m.simple_oto_cta()}
              </MkLink>
              <MkLink to="/mulai" variant="secondary" arrow>
                {m.simple_mulai_how()}
              </MkLink>
            </div>
            <p className="text-[13px] text-[var(--mk-fg-muted)]">{m.simple_oto_cta_note()}</p>
          </Container>
        </section>

        <section className="py-16 lg:py-24">
          <Container>
            <ul className="grid gap-6 lg:grid-cols-3">
              {blocks.map((b) => (
                <li key={b.t} className="mk-card-white flex flex-col gap-2 p-6">
                  <h3 className="font-heading text-lg font-semibold tracking-[-0.02em]">{b.t}</h3>
                  <p className="mk-muted leading-relaxed">{b.d}</p>
                </li>
              ))}
            </ul>
          </Container>
        </section>

        <section className="py-16 lg:py-24">
          <Container className="flex flex-col gap-8">
            <SectionHead title={m.simple_oto_faq_title()} />
            <ul className="mx-auto flex w-full max-w-3xl flex-col gap-4">
              {faqs.map((f) => (
                <li key={f.q} className="mk-card-white flex flex-col gap-1.5 p-5 text-left">
                  <h3 className="font-heading text-[17px] font-semibold tracking-[-0.02em]">{f.q}</h3>
                  <p className="mk-muted leading-relaxed">{f.a}</p>
                </li>
              ))}
            </ul>
            <div className="flex flex-col items-center gap-2">
              <MkLink to="/sign-in" search={{ redirect: '/plan?flow=new' }}>
                {m.simple_oto_cta()}
              </MkLink>
              <p className="text-[13px] text-[var(--mk-fg-muted)]">{m.simple_oto_cta_note()}</p>
            </div>
          </Container>
        </section>
      </main>
      <MkFooter />
    </div>
  )
}
